<template>
  <div class="topbar">
    <router-link :to="{name: buttonTo}"><i class="fas fa-chevron-left fa-margin-right"></i>{{ buttonText }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'navbar-top',
  props: {
    buttonText: {
      type: String,
      default: 'Back',
    },
    buttonTo: {
      type: String,
      default: '/',
    },
  },
  data() {
    return {};
  },
  methods: {
    onClick(eventName) {
      this.$emit('topbar-click', eventName);
    },
  },
};
</script>

<style scoped>
.topbar {
    background:#267edb;
    color: #fff;
    padding: 10px 20px;
    margin-bottom: 20px;
}
.topbar a {
    color: #fff;
}
</style>
